import { addLastPrefixEN } from '../transforms/addLastPrefix';
import { formatOrdinalEN } from '../transforms/formatOrdinal';
import { overrideBaseLocale } from './base-config';
export var enUS = overrideBaseLocale('en-US', {
    dayOfMonthOrdinal: {
        options: {
            day: 'numeric',
        },
        transforms: [formatOrdinalEN],
    },
    lastDayOfWeekLong: {
        options: {
            weekday: 'long',
        },
        transforms: [addLastPrefixEN],
    },
});
//# sourceMappingURL=en-US.js.map